export const KEEP_ALIVE_ID = 'keep-alive';
